import { get } from 'partial.lenses'

/**
 * Get current content ID
 *
 * @param {Object} store Redux store data
 * @returns {number} Current content ID
 */
export const getCurrentContentId = store => get(['content', 'currentContentId'], store)
